/* outside */
const UPDATE_INPUT_VALUE = 'outside/UPDATE_FORM_VALUE'
const SET_OUTSIDE_DATA = 'oustide/SET_OUTSIDE_DATA'
const SAVE_OUTSIDE_DATA = 'oustide/SAVE_OUTSIDE_DATA'
const OPEN_MODAL = 'oustide/OPEN_MODAL'
const CLOSE_MODAL = 'oustide/CLOSE_MODAL'

export default {
  UPDATE_INPUT_VALUE,
  SET_OUTSIDE_DATA,
  SAVE_OUTSIDE_DATA,
  OPEN_MODAL,
  CLOSE_MODAL
}


// WEBPACK FOOTER //
// ./src/actions/outsideTypes.js